import { ApolloLink } from 'apollo-link';

export const contextLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response: any) => {
    if (operation.getContext().nodeIdForShareTargets) {
      response.data.nodeById.shareTargets['nodeId'] = operation.getContext().nodeIdForShareTargets;
      response.data.nodeById.shareTargets.groupTargets[
        'nodeId'
      ] = operation.getContext().nodeIdForShareTargets;
      response.data.nodeById.shareTargets.orgPeopleTargets[
        'nodeId'
      ] = operation.getContext().nodeIdForShareTargets;
      response.data.nodeById.shareTargets.otherPeopleTargets[
        'nodeId'
      ] = operation.getContext().nodeIdForShareTargets;
      // Due to wrong nodeId in orgPeoplTargets and otherPeopleTargets coming from backend
      response.data.nodeById.shareTargets.otherPeopleTargets.targets.forEach(function (part: any) {
        part.nodeId = operation.getContext().nodeIdForShareTargets;
      });
      response.data.nodeById.shareTargets.orgPeopleTargets.targets.forEach(function (part: any) {
        part.nodeId = operation.getContext().nodeIdForShareTargets;
      });
      return response;
    } else {
      return response;
    }
  });
});
